import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ClinicalNoteApi } from '../../../apis/ClinicalNoteApi/ClinicalNoteApi';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { AppMedError } from '../../../error/AppMedError';
import { ClinicalNoteType, IClinicalNote } from '../ClinicalNote';

export function useSignCounsellingNote(patientId?: string | number) {
    const queryClient = useQueryClient();

    return useMutation<IClinicalNote, AppMedError, string>({
        mutationKey: [QueryKeys.clinicalNotes, ClinicalNoteType.Counselling, 'sign'],
        mutationFn: async (noteId: string) => {
            return await ClinicalNoteApi.signCounsellingNote(noteId);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [QueryKeys.clinicalNotes, ClinicalNoteType.Counselling] });
            if (patientId != null)
                queryClient.invalidateQueries({ queryKey: [QueryKeys.clinicalNoteActivity, ClinicalNoteType.Counselling, String(patientId)] });
        },
    });
}
